export const EMAIL_REGEX = /^(?=.{5,200}$)([\w\-]+)([\w\.\-]*)@([\w\-]+)\.([\w\-]*)\w+([-.]\w+)*$/i;



// WEBPACK FOOTER //
// ./src/constant/regx.js